module.exports = __webpack_public_path__ + "static/media/event-services-img13.89b7addd.jpg";